import { GridCellProps } from "@progress/kendo-react-grid";


export const UccCell = (props: GridCellProps) => {
    const ucc = props.dataItem.ucc || [];
    const text = ucc.map((u: any) => u.ra_ucc_code)

    return (
        <td
            aria-colindex={props.columnIndex}
            role="gridcell"
            onContextMenu={(ev) => props.onContextMenu!(ev, props.dataItem)}
        >
            {text.map((code: string, index: number) => (
                <span key={index} style={{
                    display: "block",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    direction: "rtl", // to show ellipsis at the start if text is too long
                    textAlign: "left"
                }}>
                    {code}
                </span>
            ))}
        </td>
    )
};